// import * as services from '@/services'

import sectionsSummary from '@/data/sections-summary.js'

export default {
  namespaced: true,

  state: {
    sections: {
      list: sectionsSummary.sections
    }
  },

  // actions: {
  //   async FETCH_ALL({ commit }) {
  //     const { content } = await services.sections.getSectionsSummary()

  //     commit('SET_SECTIONS_LIST', content.sections)
  //   }
  // },

  mutations: {
    SET_SECTIONS_LIST(state, list) {
      state.sections.list = list
    }
  }
}
